module.exports = "<form class=\"form-horizontal modify-form\" name=\"modifyForm\" novalidate>\n\t<div class=\"modal-header\">\n\t\t创建存储卷\n\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" data-ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button>\n\t</div>\n\t<div class=\"modal-body\">\n\t\t内容区域\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn bp-btn-primary\" ng-click=\"vm.confirmSubmit()\">确定</button>\n\t</div>\n</form>"


//////////////////
// WEBPACK FOOTER
// ./example/app/components/popup/popup.html
// module id = 275
// module chunks = 40